import { render } from "./AddPixel.vue?vue&type=template&id=89c81d52"
import script from "./AddPixel.vue?vue&type=script&lang=js"
export * from "./AddPixel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__